const ZONE_TYPE_MAIN = "MainZone";
const ZONE_TYPE_ENDORPROSUMER = "EndZoneOrProsumer";
const ZONE_TYPE_NEITHERORCONSUMER = "NeitherOrConsumer";

const ZONE_TYPES = {
  MAIN: ZONE_TYPE_MAIN,
  ENDORPROSUMER: ZONE_TYPE_ENDORPROSUMER,
  NEITHERORCONSUMER: ZONE_TYPE_NEITHERORCONSUMER
};

const ZONE_TYPE_LABELS = {
  [ZONE_TYPE_MAIN]: "Main Zone",
  [ZONE_TYPE_ENDORPROSUMER]: "End Zone",
  [ZONE_TYPE_NEITHERORCONSUMER]: "Neither"
};

export default { ZONE_TYPES, ZONE_TYPE_LABELS };
export { ZONE_TYPES, ZONE_TYPE_LABELS };
